let firstTagLoad = true;
let jsonNews = null;

import lowerWithoutAccent from './lib/lowerWithoutAccent';
import newsApi from '../../api/news-api';
const GET_NEWS_RESPONSE = 'getNewsResponse';
const GET_NEWS_FAILURE = 'getNewsFailure';
const GET_TAGS_RESPONSE = 'getTagsResponse';
const GET_TAGS_FAILURE = 'getTagsFailure';
const SELECT_TAG = 'selectTag';
const PUSH_TAG = 'pushTag';
const SET_CURRENT_PAGE = 'setCurrentPage';
const ALL_THEME_TAG = { tag: 'Összes téma', url: 'osszes' };
const mapTag = (tag) => {
	const url = lowerWithoutAccent(tag);
	return {
		tag,
		url
	};
};
const mapTags = (arr) => arr.map(mapTag);
function transformTags(state) {
	if (state && state.tags && state.tags.length) {
		state.tags = mapTags(state.tags);
	}
}

function transformArticleTags(state) {
	if (state && state.newsList && state.newsList.length) {
		state.newsList.forEach((article) => {
			let tags;
			if (article && article.tags && article.tags.length) {
				tags = mapTags(article.tags);
			}
			article.tags = tags || [];
		});
	}
}

const newsState = {
	newsList: [],
	tags: [],
	loading: false,
	technicalError: false,
	selectedTag: {},
	allThemeTag: ALL_THEME_TAG,
	// Pager opts
	pagerStart: 0,
	allNewsCount: 0,
	currentPage: 1,
	visibleHits: 0
};

const newsActions = {
	getNews({ commit }, params) {
		return new Promise((resolve, reject) => {
			newsApi
				.getNews(params)
				.then((response) => {
					commit(GET_NEWS_RESPONSE, response.data);
					resolve();
				})
				.catch((error) => {
					commit(GET_NEWS_FAILURE, error.data);
					console.log(error);
					reject();
				});
		});
	},
	getTags({ commit }, params) {
		return new Promise((resolve, reject) => {
			newsApi
				.getTags(params)
				.then((response) => {
					commit(GET_TAGS_RESPONSE, response.data);
					resolve();
				})
				.catch((error) => {
					commit(GET_TAGS_FAILURE, error.data);
					reject();
				});
		});
	},
	selectTag({ commit }, tag) {
		commit(SELECT_TAG, tag);
	},
	pushTag({ commit }, tag) {
		commit(PUSH_TAG, tag);
	},
	setCurrentPage({ commit }, value) {
		commit(SET_CURRENT_PAGE, value);
	},
	getJsonData({ commit }) {
		return new Promise((resolve, reject) => {
			newsApi
				.getJsonData()
				.then((response) => {
					jsonNews = response.data;
					resolve();
				})
				.catch((error) => {
					commit(GET_TAGS_FAILURE, error.data.tags);
					commit(GET_NEWS_RESPONSE, error.data.news);
					reject();
				});
		});
	},
	getJsonTags({ commit }) {
		return new Promise((resolve) => {
			commit(GET_TAGS_RESPONSE, jsonNews.tags);
			resolve();
		});
	},
	getJsonNews({ commit }, params) {
		return new Promise((resolve) => {
			const copy = JSON.parse(JSON.stringify(jsonNews));
			const filteredHits = copy.news.hits.filter((hit) => {
				if (params.tag === ALL_THEME_TAG.tag || params.tag === null) {
					return true;
				}
				return hit.tags.includes(params.tag);
			});
			const numberOfHits = filteredHits.length;
			const hits = filteredHits.slice(params.start, params.start + params.rows);
			const paginatedNews = { numberOfHits, hits };
			commit(GET_NEWS_RESPONSE, paginatedNews);
			resolve();
		});
	}
};

const newsMutations = {
	[GET_NEWS_RESPONSE](state, data) {
		state.newsList = data.hits;
		state.visibleHits = data && data.hits && data.hits.length ? data.hits.length : 0;
		transformArticleTags(state);
		state.loading = false;
		// MOCK
		state.pagerStart = 0;
		state.allNewsCount = data.numberOfHits;
		//
	},
	[GET_NEWS_FAILURE](state) {
		state.technicalError = true;
		state.loading = false;
	},
	[GET_TAGS_RESPONSE](state, data) {
		state.tags = data;
		if (firstTagLoad) {
			firstTagLoad = false;
			transformTags(state);
		}
		state.loading = false;
	},
	[GET_TAGS_FAILURE](state) {
		state.technicalError = true;
		state.loading = false;
	},
	[SELECT_TAG](state, tag) {
		state.selectedTag = tag;
	},
	[PUSH_TAG](state, tag) {
		state.tags.push(tag);
	},
	[SET_CURRENT_PAGE](state, value) {
		state.currentPage = value;
	}
};

export default {
	namespaced: true,
	state: newsState,
	mutations: newsMutations,
	actions: newsActions
};
